import { useLazyQuery } from '@apollo/client'
import { useState, useMemo } from 'react'
import { GET_PUBLISHER_LEAD_FORMS } from '../../../../graphql/media-buying-queries'
import { showNotification } from '../../../../utils/notifications'

export const useLeadForms = (publisherId, pageId, campaignId) => {
    const [forms, setForms] = useState([])
    const [activeTab, setActiveTab] = useState('active')

    const [fetchLeadForms, { loading }] = useLazyQuery(GET_PUBLISHER_LEAD_FORMS, {
        variables: { publisher_id: publisherId, page_id: pageId, campaign_id: campaignId },
        fetchPolicy: 'network-only',
        onCompleted: (data) => {
            setForms(data?.publisherPageLeadForms || [])
        },
        onError: (err) => {
            err.graphQLErrors.forEach((e) => {
                showNotification(e.message, 'error')
            })
        },
    })

    const filteredForms = useMemo(() => {
        return forms.filter((f) => f.status === (activeTab === 'active' ? 'ACTIVE' : 'ARCHIVED'))
    }, [forms, activeTab])

    return {
        forms: filteredForms,
        allForms: forms,
        loading,
        fetchLeadForms,
        activeTab,
        setActiveTab,
    }
}
